export default __webpack_public_path__ + "static/media/banner.d8fca9b8.jpg";